import { render, staticRenderFns } from "./multiple-event-durations.vue?vue&type=template&id=335cfa87"
import script from "./multiple-event-durations.vue?vue&type=script&lang=js"
export * from "./multiple-event-durations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports